module.exports = __webpack_public_path__ + "static/media/apple.ace9f5ba.png";